/*!
 * Copyright (c) 2017-present Cliqz GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
  ":style(display: block !imp",
  "+js(acs, addEventListener,",
  "+js(acs, document.querySel",
  "+js(nosiif, visibility, 10",
  "app_vars.force_disable_adb",
  "+js(set, blurred, false)",
  "+js(acs, eval, replace)",
  "ectorAll, popMagic)",
  "+js(acs, document.",
  "+js(rmnt, script, ",
  "decodeURIComponent",
  "^script:has-text(",
  "+js(no-fetch-if, ",
  "[href^=\"https://",
  "[href^=\"http://",
  "+js(aopw, _pop)",
  "+js(no-xhr-if, ",
  "createElement, ",
  "+js(nano-sib",
  "+js(nostif, ",
  "div[class^=\"",
  "notification",
  " !important",
  ", noopFunc)",
  "+js(nowoif)",
  "+js(aeld, ",
  "+js(aopr, ",
  "+js(aopw, ",
  "background",
  "+js(acs, ",
  "+js(set, ",
  "container",
  "div[id^=\"",
  "div[style",
  ",amazon.",
  ",google.",
  "https://",
  ".*,xham",
  "300x250",
  "consent",
  "content",
  "message",
  "privacy",
  "wrapper",
  ".co.uk",
  ".com##",
  "[data-",
  "accept",
  "banner",
  "bottom",
  "cookie",
  "Cookie",
  "google",
  "notice",
  "policy",
  "widget",
  ".com,",
  "block",
  "click",
  "movie",
  "popup",
  "video",
  "width",
  ",img",
  ".com",
  ".net",
  ".nl,",
  ".xyz",
  "#@#.",
  "+js(",
  "0px;",
  "gdpr",
  "html",
  "ight",
  "news",
  "side",
  "tube",
  "www.",
  " > ",
  ".*,",
  ".de",
  "age",
  "box",
  "ent",
  "top",
  "web",
  "xxx",
  "__",
  ", ",
  ",p",
  ": ",
  ".*",
  ".f",
  ".p",
  ".s",
  ".t",
  "\"]",
  "##",
  "=\"",
  "00",
  "ab",
  "ac",
  "ad",
  "Ad",
  "al",
  "am",
  "an",
  "ap",
  "ar",
  "at",
  "au",
  "bi",
  "bo",
  "ca",
  "ch",
  "ck",
  "co",
  "ct",
  "d-",
  "da",
  "de",
  "di",
  "do",
  "e-",
  "ed",
  "el",
  "en",
  "er",
  "es",
  "et",
  "fi",
  "fo",
  "ft",
  "g-",
  "ga",
  "go",
  "he",
  "ho",
  "ic",
  "id",
  "il",
  "im",
  "in",
  "it",
  "la",
  "le",
  "li",
  "lo",
  "ma",
  "me",
  "mi",
  "mo",
  "mp",
  "na",
  "ne",
  "no",
  "ol",
  "on",
  "op",
  "or",
  "ot",
  "ov",
  "po",
  "ra",
  "re",
  "ro",
  "ru",
  "s_",
  "s-",
  "sc",
  "se",
  "sh",
  "si",
  "sk",
  "so",
  "sp",
  "ss",
  "st",
  "t-",
  "ta",
  "te",
  "ti",
  "to",
  "ub",
  "ul",
  "um",
  "un",
  "up",
  "ur",
  "us",
  "ut",
  "ve",
  "vi",
  "xt",
  "y-",
  " ",
  "_",
  "-",
  ",",
  ";",
  ":",
  ".",
  "(",
  ")",
  "[",
  "/",
  "#",
  "^",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "A",
  "b",
  "B",
  "c",
  "C",
  "d",
  "D",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "L",
  "m",
  "M",
  "n",
  "o",
  "p",
  "P",
  "q",
  "r",
  "R",
  "s",
  "S",
  "t",
  "T",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];